import { lightColor } from './Colors';

const { info, dark } = lightColor;

const topBarHeight = '3rem';

export default {
  html: {
    scrollBehavior: 'smooth',
  },
  '*, *::before, *::after': {
    margin: 0,
    padding: 0,
  },
  'a, a:link, a:visited': {
    textDecoration: 'none !important',
  },
  'a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited': {
    color: `${dark.main} !important`,
    transition: 'color 150ms ease-in !important',
  },
  'a.link:hover, .link:hover, a.link:focus, .link:focus': {
    color: `${info.main} !important`,
  },
  '.topbar': {
    height: topBarHeight,
  },
  '.page-content-wrapper': {
    'padding-top': topBarHeight,
  },
};
